import { render } from "./InspectionReport.vue?vue&type=template&id=91ea1908&scoped=true"
import script from "./InspectionReport.vue?vue&type=script&lang=js"
export * from "./InspectionReport.vue?vue&type=script&lang=js"

import "./InspectionReport.vue?vue&type=style&index=0&id=91ea1908&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ea1908"]])

export default __exports__